import QuestionCollapsible from './QuestionCollapsible.component';

export default QuestionCollapsible;
